// extracted by mini-css-extract-plugin
export default {"container":"about_container__wFLAo","websiteName":"about_websiteName__XrqdV"};